import { Box, SxProps, Theme } from "@mui/material";
import dynamic from "next/dynamic";
import { useWfPriceIndexQuery } from "src/api/client/price-chart.api";
import type { IBenchmarkProps } from "src/components/common/benchmark/wikifolio-detail-benchmark";
import { ErrorBoundary } from "src/components-mui/common/error-boundary/error-boundary";
import { DetailBenchmarkLoadingState } from "src/components-mui/pages/detail/detail-benchmark-loading-state";

const WikifolioDetailBenchmark = dynamic(
    () => import("src/components/common/benchmark/wikifolio-detail-benchmark").then(module => module.WikifolioDetailBenchmark),
    { loading: () => <DetailBenchmarkLoadingState /> }
);

interface IDetailBenchmarkProps extends Pick<IBenchmarkProps, "wikifolioId" | "wikifolioStatus" | "creationDate" | "dict" | "baseCurrency"> {
    sx?: SxProps<Theme>;
}

const useRequestPriceIndexWithoutWaitingForChartChunk = (wikifolioId: string) => {
    useWfPriceIndexQuery(wikifolioId);
};

export const DetailBenchmark = ({ sx, ...benchmarkProps }: IDetailBenchmarkProps) => {
    useRequestPriceIndexWithoutWaitingForChartChunk(benchmarkProps.wikifolioId);

    return (
        <Box sx={sx}>
            <ErrorBoundary>
                <WikifolioDetailBenchmark {...benchmarkProps} />
            </ErrorBoundary>
        </Box>
    );
};
